var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.entity
        ? _c("app-detail-header", {
            attrs: {
              "show-toggle": true,
              entity: _vm.entity,
              "show-new": false,
              "show-print": false,
              "show-delete":
                !!_vm.entity &&
                !_vm.entity.deleted &&
                _vm.canConvert &&
                !_vm.entity.isNew,
              "show-save":
                !!_vm.entity && !_vm.entity.deleted && !_vm.entity.quoteId,
              "show-lock": false,
              "show-convert": !_vm.entity.deleted && _vm.canConvert,
            },
            on: { appDetailHeaderButtonClicked: _vm.onHeaderButtonClicked },
          })
        : _vm._e(),
      _c("div", { staticClass: "columns is-gapless" }, [
        _c(
          "div",
          { staticClass: "column is-narrow" },
          [
            _vm.entity
              ? _c("booking-side-menu", {
                  ref: "sideMenu",
                  attrs: { "entity-name": `${_vm.entity.claimNo}` },
                  on: { "select-booking": _vm.changeBooking },
                  model: {
                    value: _vm.entity,
                    callback: function ($$v) {
                      _vm.entity = $$v
                    },
                    expression: "entity",
                  },
                })
              : _vm._e(),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "column" },
          [
            _vm.entity
              ? _c("router-view", {
                  key: _vm.$route.fullPath,
                  ref: "currentChild",
                  attrs: { "is-tiled": false, "route-name": _vm.$route.name },
                  model: {
                    value: _vm.entity,
                    callback: function ($$v) {
                      _vm.entity = $$v
                    },
                    expression: "entity",
                  },
                })
              : _vm._e(),
          ],
          1
        ),
      ]),
      _c(
        "unsaved-modal",
        {
          attrs: { active: _vm.isUnsavedModalActive },
          on: {
            "update:active": function ($event) {
              _vm.isUnsavedModalActive = $event
            },
            close: function ($event) {
              return _vm.closeModal()
            },
            skipSave: function ($event) {
              return _vm.skipSave()
            },
            saveContinue: function ($event) {
              return _vm.saveContinue()
            },
          },
        },
        [
          _c("p", { attrs: { slot: "text-title" }, slot: "text-title" }, [
            _vm._v("Unsaved Changes"),
          ]),
          _c("p", { attrs: { slot: "text-content" }, slot: "text-content" }, [
            _vm._v("There are unsaved changes. Please select action below"),
          ]),
        ]
      ),
      _vm.entity
        ? _c(
            "confirm-modal",
            {
              attrs: {
                active: _vm.isConfirmModalActive,
                "ok-text": "Yes",
                "cancel-text": "No",
              },
              on: {
                "update:active": function ($event) {
                  _vm.isConfirmModalActive = $event
                },
                ok: function ($event) {
                  return _vm.handleDelete()
                },
                cancel: function ($event) {
                  _vm.isConfirmModalActive = !_vm.isConfirmModalActive
                },
              },
              model: {
                value: _vm.entity,
                callback: function ($$v) {
                  _vm.entity = $$v
                },
                expression: "entity",
              },
            },
            [
              _c("p", { attrs: { slot: "text-title" }, slot: "text-title" }, [
                _vm._v("Delete Booking"),
              ]),
              _c(
                "p",
                { attrs: { slot: "text-content" }, slot: "text-content" },
                [
                  _vm._v(" Booking "),
                  _c(
                    "span",
                    { staticClass: "has-text-primary has-text-weight-bold" },
                    [_vm._v(_vm._s(`${_vm.entity.vehicleRegistrationNo}`))]
                  ),
                  _vm._v(" will be deleted. Continue? "),
                ]
              ),
            ]
          )
        : _vm._e(),
      _vm.isBookingConvertQuoteActive
        ? _c("booking-convert-to-quote-simple", {
            attrs: {
              active: _vm.isBookingConvertQuoteActive,
              "quote-booking-id": _vm.innerBookingId,
              entity: _vm.entity,
            },
            on: {
              "update:active": function ($event) {
                _vm.isBookingConvertQuoteActive = $event
              },
              close: _vm.closeBookingConvertQuote,
            },
            model: {
              value: _vm.loadOptions,
              callback: function ($$v) {
                _vm.loadOptions = $$v
              },
              expression: "loadOptions",
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }